import Entity from '../entity'

export default class Zone extends Entity<number>{
    manager_id: number;
    supervisor_id: number;
    name: string;
    color: string;
}


